import { Dispatch } from 'react'
import { MetaState, MetaAction, SET_META } from './types'

export const setMeta = (dispatch: Dispatch<MetaAction>) => (data: Partial<MetaState>) => {
	dispatch({ type: SET_META, payload: { ...data } })
}
